// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__XIedX","clinicsSelect":"TableHeading_clinicsSelect__4YBjL"};